// The central event vocabulary for the SDK. EventBus is transport; SDKEvent is the
// contract every layer (widget lifecycle, ad lifecycle, playback, tracking, errors)
// speaks so future widgets/modules can consume events without depending on the
// engine-specific vocabularies (PlayerEvent, VastPipelineEvent, TrackingEvents) that
// produce them. New categories/events append here without touching consumers.
export const SDKEvent = Object.freeze({
  // SDK Lifecycle - reserved for a future SDK-level orchestrator managing multiple
  // widgets. Not wired yet: VideoWidget is currently the only entry point.
  SDK_INITIALIZED: 'sdk:initialized',
  SDK_READY: 'sdk:ready',
  SDK_DESTROYED: 'sdk:destroyed',

  // Widget Lifecycle
  WIDGET_CREATED: 'widget:created',
  WIDGET_INITIALIZED: 'widget:initialized',
  WIDGET_READY: 'widget:ready',
  WIDGET_DESTROYED: 'widget:destroyed',

  // Ad Lifecycle (bridged from VastPipelineEvent)
  AD_REQUEST_STARTED: 'ad:requestStarted',
  AD_REQUEST_COMPLETED: 'ad:requestCompleted',
  AD_LOADED: 'ad:loaded',
  AD_FAILED: 'ad:failed',

  // Playback (bridged from PlayerEvent)
  PLAYER_INITIALIZED: 'player:initialized',
  PLAYER_READY: 'player:sdkReady',
  PLAYER_DESTROYED: 'player:destroyed',
  PLAYBACK_STARTED: 'playback:started',
  PLAYBACK_PAUSED: 'playback:paused',
  PLAYBACK_RESUMED: 'playback:resumed',
  PLAYBACK_PROGRESS: 'playback:progress',
  PLAYBACK_COMPLETED: 'playback:completed',

  // Tracking
  TRACKING_SENT: 'tracking:sent',
  TRACKING_FAILED: 'tracking:failed',

  // Advertisement (bridged from PlayerEvent; what TrackingManager consumes)
  AD_IMPRESSION: 'ad:impression',
  AD_CLICK: 'ad:click',

  // Errors
  PLAYER_ERROR: 'error:player',
  VAST_ERROR: 'error:vast',
});
